import { Form, Input, Button } from 'antd'
import { useTranslation } from 'react-i18next'

const RequestNewPasswordForm = ({ onBackToLogin, onSubmit }) => {
  const { t } = useTranslation()

  return (
    <Form layout="vertical" onFinish={onSubmit} requiredMark={false}>
      <Form.Item
        label={t('Login.ExistingEmail')}
        name="email"
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterEmail'),
          },
          {
            type: 'email',
            message: t('Register.error.PleaseEnterValidEmail'),
          },
        ]}
      >
        <Input placeholder="" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {t('Login.Send')}
        </Button>
        <Button type="link" onClick={onBackToLogin}>
          {t('Login.BackToLogin')}
        </Button>
      </Form.Item>
    </Form>
  )
}
export default RequestNewPasswordForm
